import service from "../services/program.membership.tiers";
import notification from "../services/notification";
import { getField, updateField } from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        errors: {},
        pointsMechanicsList: null,
        tierList: [],
        tier: null,
        badge: null,
        memberListByTier: [],
        param: {
            page: 1,
            payload: {
                tier_uuid: null,
                sub_tier_id: null,
                filters: {
                    keyword: "",
                    column: "all"
                }
            }
        },
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        }
    },
    mutations: {
        updateField,
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        setPointsMechanicList(state, payload) {
            state.pointsMechanicsList = payload;
        },
        setTierList(state, payload) {
            state.tierList = payload;
        },
        setTier(state, payload) {
            state.tier = payload;
        },
        setBadge(state, payload) {
            state.badge = payload;
        },
        setParam(state, param) {
            state.param = param;
        },
        setMemberListByTier(state, memberListByTier) {
            state.memberListByTier = memberListByTier;
        },
        setInitialPageCount(state, list) {
            state.pagination.initialPageCount = list.length;
        },
        setCurrentPage(state, page) {
            state.pagination.currentPage = page;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                          state.pagination.prevPage +
                      1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                      state.pagination.totalPerPage -
                      1
                    : 0;
        }
    },
    getters: {
        getField,
        tier: state => state.tier
    },
    actions: {
        getPointsMechanicsList: async ({ commit }) => {
            commit("setIsLoading", true);
            try {
                const response = await service.getPointsMechanicsList();
                commit("setPointsMechanicList", response.list);
            } catch (errors) {
                notification.warning("Oops, cannot get points mechanics list.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        getTierList: async ({ commit }, param) => {
            commit("setIsLoading", true);
            try {
                // console.log(param);
                const response = await service.getTierList(param);
                commit("setTierList", response.data);
            } catch (errors) {
                notification.warning("Oops, cannot get tier list.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        createTier: async ({ commit }, payload) => {
            commit("setIsLoading", true);
            commit("setErrors", {});

            try {
                await service.createTier(payload);
                notification.success("Saved successfully.");
            } catch (errors) {
                commit("setErrors", errors.errors ? errors.errors : {});
                notification.warning("Oops, cannot create tier.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        updateTier: async ({ commit }, payload) => {
            commit("setIsLoading", true);
            commit("setErrors", {});

            try {
                const { data } = await service.updateTier(payload);
                commit("setTier", data);
                notification.success("Saved successfully.");
            } catch (errors) {
                commit("setErrors", errors.errors ? errors.errors : {});
                notification.warning("Oops, cannot update tier.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        deleteTier: async ({ commit }, id) => {
            commit("setIsLoading", true);
            try {
                let response = await service.deleteTier(id);
                notification.success(response.message);
            } catch (errors) {
                notification.warning(errors.errors.message);
            } finally {
                commit("setIsLoading", false);
            }
        },
        getTier: async ({ commit }, id) => {
            commit("setIsLoading", true);
            commit("setErrors", {});

            try {
                const { data } = await service.getTier(id);

                if (!data.validity.cycle_expiration) {
                    data.validity["cycle_expiration"] = {
                        month: null,
                        day: null
                    };
                }

                commit("setTier", data);
            } catch (errors) {
                notification.warning("Oops, cannot retrieve tier details.");
            } finally {
                commit("setIsLoading", false);
            }
        },
        getMemberListByTier: async ({ commit }, param) => {
            try {
                commit("setIsLoading", true);
                commit("setMemberListByTier", []);

                let response = await service.getMemberListByTier(param);

                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }

                commit("setMemberListByTier", response.list);
                commit("setPagination", response);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setIsLoading", false);
            }
        },
        publishTier: async ({ commit }, param) => {
            try {
                commit("setIsLoading", true);
                let response = await service.publishTier(param);
                notification.success(response.message);
            } catch (errors) {
                commit("setErrors", errors);

                notification.warning(errors.errors.message);
            } finally {
                commit("setIsLoading", false);
            }
        },
        moveMemberTier: async ({ commit }, payload) => {
            try {
                commit("setIsLoading", true);
                const { message } = await service.moveMemberTier(payload);

                notification.success(message);
            } catch (errors) {
                notification.warning(message);
            } finally {
                commit("setIsLoading", false);
            }
        }
    }
};
